import { FrequencyCappingServiceClient } from '@pushwoosh/rpc-service-client/pushwoosh/frequency_capping/Frequency_cappingServiceClientPb';
import { 
  Capping,
  FrequencyCapping,
  GetFrequencyCappingRequest,
  GetFrequencyCappingResponse,
  CreateFrequencyCappingRequest,
  CreateFrequencyCappingResponse,
  UpdateFrequencyCappingRequest,
  UpdateFrequencyCappingResponse
 } from '@pushwoosh/rpc-service-client/pushwoosh/frequency_capping/frequency_capping_pb';

 export type FrequencyCappingExportClasses = {
  FrequencyCappingServiceClient: typeof FrequencyCappingServiceClient;
  Capping: typeof Capping;
  FrequencyCapping: typeof FrequencyCapping;
  GetFrequencyCappingRequest: typeof GetFrequencyCappingRequest;
  GetFrequencyCappingResponse: typeof GetFrequencyCappingResponse;
  CreateFrequencyCappingRequest: typeof CreateFrequencyCappingRequest;
  CreateFrequencyCappingResponse: typeof CreateFrequencyCappingResponse;
  UpdateFrequencyCappingRequest: typeof UpdateFrequencyCappingRequest;
  UpdateFrequencyCappingResponse: typeof UpdateFrequencyCappingResponse;
};

export const frequencyCapping: FrequencyCappingExportClasses = {
  Capping,
  FrequencyCapping,
  GetFrequencyCappingRequest,
  GetFrequencyCappingResponse,
  CreateFrequencyCappingRequest,
  CreateFrequencyCappingResponse,
  UpdateFrequencyCappingRequest,
  UpdateFrequencyCappingResponse,
  FrequencyCappingServiceClient
}